<template>
    <div class="order-wrapper" v-loading="loading" element-loading-text="拼命加载中">
        <div class="section-wrapper">
            <order_head :order="orderData" :check_type="check_type"></order_head>
            <!--财务信息-->
            <el-tabs  type="border-card" class="order-detail-section mg20"
                     v-model="activeTab">
                <el-tab-pane label="财务信息" name="2">
                    <order_line :order.sync="revise_order" :type="orderData.type" :tab="params.FINANCE_LINE" @openInvoiceDialog="openEditDialog"></order_line>
                </el-tab-pane>
            </el-tabs>
            <div class="order-detail-section mg20" v-if="activeTab == params.FINANCE_LINE">
                <h3 style="color: red">补充信息如下：</h3>
                <div class="order-detail-section mg20">
                    <div class="order-userInfo">
                        <order_invoice v-if="revise_order.finance" :order="revise_order"></order_invoice>
                    </div>
                </div>
            </div>
            <!--产品信息-->
            <product-basic-info  :order.sync="orderData"></product-basic-info>
            <order_contract_time :order.sync="orderData"></order_contract_time>
            <div class="order-detail-section mg20"
                    v-if="orderData.finance && orderData.finance.express && orderData.finance.invoice && orderData.type != params.TYPE_TRY_OUT">
                <h3>其他信息</h3>
                <div class="order-userInfo">
                    <order_invoice :order.sync="orderData"></order_invoice>
                </div>
            </div>
        </div>

        <!-- 发票信息弹窗 -->
        <invoice-table
            v-if="dialogInvoiceVisible"
            :invoiceForm="invoiceForm"
            :isFillInvoice="true"
            :forceApplyOpen="forceApplyOpen"
            :customer_id="orderData.customer_id"
            :contract-amount="orderData.finance && orderData.finance.total_amount"
            :invoices="orderData.finance && orderData.finance.invoice"
            @handleAddInvoice="fillInvoice">
        </invoice-table>
    </div>
</template>
<script>
    import OrderService from "~/services/order";
    import {OrderMixin} from "~/services/OrderMixin";
    import Params from "~/config/params";
    import order_contract from "~/views/order/partial/order_contract.vue";
    import order_invoice from "~/views/order/partial/order_invoice.vue";
    import order_line from "~/views/order/partial/order_line.vue";
    import order_head from "~/views/order/partial/order_head.vue";
    import order_contract_time from "~/views/order/partial/order_contract_time.vue";
    import InvoiceTable from "~/views/order/invoiceTable.vue";
    import CustomerService from "~/services/customer";
    import http from "~/common/http";

    export default {
        mixins: [OrderMixin],
        data() {
            return {
                revise_order: {
                    finance:{
                        invoice:[]
                    }
                },
                revise_id: this.$route.query['revise_id'],//修订id,
                dialogInvoiceVisible: false, //发票弹窗
                invoiceForm: null, // 发票表单
                forceApplyOpen: false, // 新增forceApplyOpen属性
            };
        },
        watch:{
            revise_order(d,v){
                this.getReviseContent(this.id);
            }
        },
        components: {
            order_contract,
            order_invoice,
            order_line,
            order_head,
            order_contract_time,
            InvoiceTable
        },
        methods: {
            getReviseContent() {
                OrderService.getReviseContent(this.revise_id).then(res => {
                    if (res.code == 0) {
                        if (res.data) {
                            if (res.data.order_block == Params.FINANCE_LINE || res.data.order_block == Params.FILL_INVOICE ) {
                                this.revise_order.finance = {};
                                this.revise_order.finance.invoice = [res.data.content];
                                this.revise_order.finance.user_id = res.data.user_id;
                                this.revise_order.is_used = res.data.is_used;
                                this.revise_order.is_cancle = res.data.is_cancle;
                            }
                        }
                    }
                })
            },

            // 打开编辑对话框 - 直接显示发票弹窗
            openEditDialog(forceApplyOpen) {
                this.getLastInvoice(this.orderData.customer_id, forceApplyOpen);
            },

            // 获取最近的发票信息
            getLastInvoice(customerId, forceApplyOpen) {
                CustomerService.getLastInvoice(customerId).then(res => {
                    if (res.code == 0 && res.data.title) {
                        let invoice = res.data;
                        this.invoiceForm = {
                            type: invoice.type,
                            title: invoice.title,
                            content: invoice.content ? parseInt(invoice.content) : '',
                            total_amount: invoice.total_amount,
                            input_at: '',
                            taxpayer_id: invoice.taxpayer_id,
                            bank_name: invoice.bank_name,
                            account: invoice.account,
                            mobile: invoice.mobile,
                            email: invoice.email,
                            address: invoice.address,
                            file_list: invoice.file_list,
                            attachment_ids: '',
                            order_id: this.orderData.id,
                            memo: invoice.content_memo,
                            // 始终选中申请开票
                            apply_open: true,
                            // 合同盖章默认为false
                            contract_seal: false
                        };
                    } else {
                        this.invoiceForm = {
                            // 始终选中申请开票
                            apply_open: true,
                            // 合同盖章默认为false
                            contract_seal: false
                        };
                    }
                    this.dialogInvoiceVisible = true;
                    this.forceApplyOpen = !!forceApplyOpen; // 确保是布尔值
                }).catch(err => {
                    this.invoiceForm = {
                        // 始终选中申请开票
                        apply_open: true,
                        // 合同盖章默认为false
                        contract_seal: false
                    };
                    this.dialogInvoiceVisible = true;
                    this.forceApplyOpen = !!forceApplyOpen; // 确保是布尔值
                })
            },

            // 保存发票信息
            fillInvoice(form) {
                if (form) {
                    if (form.file_list instanceof Array && form.file_list.length > 0) {
                        form.attachment_ids = '';
                        for (var i = 0; i < form.file_list.length; i++) {
                            form.attachment_ids += form.file_list[i]['id'] + ',';
                        }
                        form.attachment_ids = form.attachment_ids.substring(0, form.attachment_ids.lastIndexOf(','));
                    }
                    form.order_id = this.id;
                    
                    // 检查是否是FILL_INVOICE类型
                    if (this.revise_order && this.revise_order.is_used !== undefined && 
                        this.revise_id) {
                        // 获取当前revise的order_block类型
                        OrderService.getReviseContent(this.revise_id).then(res => {
                            if (res.code == 0 && res.data && res.data.order_block === Params.FILL_INVOICE) {
                                // 使用update-fill API
                                form.revise_id = this.revise_id;
                                http.post('/api/order/update-fill', form).then(res => {
                                    if (res.code == 0) {
                                        this.$message({
                                            type: 'success',
                                            message: '补充发票成功，等待审核!'
                                        });
                                        this.dialogInvoiceVisible = false;
                                        this.getOrder(this.id);
                                        this.getReviseContent(this.revise_id);
                                        // 刷新当前页面
                                        location.reload();
                                    }
                                });
                            } else {
                                // 原有逻辑
                                OrderService.fillInvoice(form).then(res => {
                                    if (res.code == 0) {
                                        this.$message({
                                            type: 'success',
                                            message: '补充发票成功，等待审核!'
                                        });
                                        this.dialogInvoiceVisible = false;
                                        this.getOrder(this.id);
                                        this.getReviseContent(this.revise_id);
                                    }
                                });
                            }
                        });
                    } else {
                        // 原有逻辑
                        OrderService.fillInvoice(form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '补充发票成功，等待审核!'
                                });
                                this.dialogInvoiceVisible = false;
                                this.getOrder(this.id);
                                this.getReviseContent(this.revise_id);
                            }
                        });
                    }
                } else {
                    this.dialogInvoiceVisible = false;
                }
            }
        },
        mounted() {
            this.params = Params;
            this.$nextTick(function () {
                this.getOrder(this.id);
                this.getReviseContent(this.revise_id);
            });
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/approve/fillOrder.vue